import classNames from "classnames";
import React, { useState } from "react";
import { usePopper } from "react-popper";
export const Tooltip = ({ className, style, children, tooltipContent, }) => {
    const [show, setShow] = useState(false);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const [arrowElement, setArrowElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: [{ name: "arrow", options: { element: arrowElement } }],
    });
    return (React.createElement("div", { ref: setReferenceElement, className: classNames({
            "popper-tooltip-target": true,
            [className]: typeof className !== "undefined",
        }), style: style, onMouseEnter: () => {
            setShow(true);
        }, onMouseLeave: () => {
            setShow(false);
        } },
        children,
        show && (React.createElement("div", { className: "popper-tooltip", style: styles.popper, ref: setPopperElement, ...attributes.popper },
            React.createElement("div", { className: "popper-tooltip-container" }, tooltipContent),
            React.createElement("div", { ref: setArrowElement, className: "popper-tooltip-arrow", style: styles.arrow })))));
};
